import { render } from "./DatasetSegments.vue?vue&type=template&id=73f87de0"
import script from "./DatasetSegments.vue?vue&type=script&lang=js"
export * from "./DatasetSegments.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__